import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

@Module
export default class ReportsModule extends VuexModule {
  registeredTrades = [] as Array<any>;
  registeredTradesTop = [] as Array<any>;
  registeredTradesPerQuarter = [] as Array<any>;
  registeredTradesTotals = [] as Array<any>;
  registeredTradesTopAreas = [] as Array<any>;
  registeredTradesDesc = [] as Array<any>;
  auctions = [] as Array<any>;
  estimator = [] as Array<any>;
  users = [] as Array<any>;
  ads = [] as Array<any>;
  auctionReport: { data: Array<any> } | null = null;
  auctionPropertiesReport: { data: Array<any> } | null = null;
  activeAdsSummaryReport: { data: Array<any> } | null = null;

  /**
   * Get registeredTradesDesc list
   * @returns Array<registeredTradesDesc>
   */
  get getregisteredTradesDesc(): Array<any> {
    return this.registeredTradesDesc;
  }

  /**
   * Get registeredTrades list
   * @returns Array<RegisteredTradeObject>
   */
  get registeredTradesReports(): Array<any> {
    return this.registeredTrades;
  }

  /**
   * Get registeredTrades list
   * @returns Array<RegisteredTradeObject>
   */
  get registeredTradesReportsPerQuarter(): Array<any> {
    return this.registeredTradesPerQuarter;
  }
  /**
   * Get registeredTrades list
   * @returns Array<RegisteredTradeObject>
   */
  get registeredTradesReportsTotals(): Array<any> {
    return this.registeredTradesTotals;
  }

  // /**
  //  * Get registeredTrades list
  //  * @returns Array<RegisteredTradeObject>
  //  */
  // get registeredTradesReportsTotals(): Array<any> {
  //   return this.registeredTradesTotals;
  // }

  /**
   * Get registeredTrades list
   * @returns Array<RegisteredTradeObject>
   */
  get registeredTradesReportsTopAreas(): Array<any> {
    return this.registeredTradesTopAreas;
  }

  /**
   * Get registeredTrades list
   * @returns Array<RegisteredTradeObject>
   */
  get registeredTradesReportsTop(): Array<any> {
    return this.registeredTradesTop;
  }

  /**
   * Get auctions list
   * @returns Array<RegisteredTradeObject>
   */
  get auctionsReports(): Array<any> {
    return this.auctions;
  }

  /**
   * Get estimator list
   * @returns Array<RegisteredTradeObject>
   */
  get estimatorReports(): Array<any> {
    return this.estimator;
  }

  /**
   * Get users list
   * @returns Array<RegisteredTradeObject>
   */
  get usersReports(): Array<any> {
    return this.users;
  }

  /**
   * Get ads list
   * @returns Array<RegisteredTradeObject>
   */
  get adsReports(): Array<any> {
    return this.ads;
  }

  /**
   * Get auction report data
   * @returns object with data array
   */
  get auctionReportData(): { data: Array<any> } | null {
    return this.auctionReport;
  }

  /**
   * Get auction properties report data
   * @returns object with data array
   */
  get auctionPropertiesReportData(): { data: Array<any> } | null {
    return this.auctionPropertiesReport;
  }

  /**
   * Get active ads summary report data
   * @returns object with data array
   */
  get activeAdsSummaryReportData(): { data: Array<any> } | null {
    return this.activeAdsSummaryReport;
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADE_REPORTS](data) {
    this.registeredTrades = data;
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADE_TOP_REPORTS](data) {
    this.registeredTradesTop = data;
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADE_TOP_AREAS_REPORTS](data) {
    this.registeredTradesTopAreas = data;
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADE_PER_QUARTER_REPORTS](data) {
    this.registeredTradesPerQuarter = data;
  }
  @Mutation
  [Mutations.SET_REGISTERED_TRADE_TOTALS_REPORTS](data) {
    this.registeredTradesTotals = data;
  }

  @Mutation
  [Mutations.SET_AUCTIONS_REPORTS](data) {
    this.auctions = data;
  }

  @Mutation
  [Mutations.SET_AUCTION_REPORT](data) {
    this.auctionReport = data;
  }

  @Mutation
  [Mutations.SET_AUCTION_PROPERTIES_REPORT](data) {
    this.auctionPropertiesReport = data;
  }

  @Mutation
  [Mutations.SET_ACTIVE_ADS_SUMMARY_REPORT](data) {
    this.activeAdsSummaryReport = data;
  }

  @Mutation
  [Mutations.SET_ESTIMATOR_REPORTS](data) {
    this.estimator = data;
  }

  @Mutation
  [Mutations.SET_ADS_REPORTS](data) {
    this.ads = data;
  }

  @Mutation
  [Mutations.SET_USERS_REPORTS](data) {
    this.users = data;
  }
  @Mutation
  [Mutations.SET_REGISTERED_TRADES_DESC](data) {
    this.registeredTradesDesc = data.data;
  }

  @Action
  [Actions.GET_ADS_REPORTS](obj) {
    const params = {
      categoryId: 0,
      propertyCategoryId: 0,
      propertyTypeId: 0,
    };

    // ApiService.setAuthorizationHeader();

    if (obj && obj.value.adTypeId) params.categoryId = obj.value.adTypeId;

    if (obj && obj.value.propertyTypesCategoryId)
      params.propertyCategoryId = obj.value.propertyTypesCategoryId;
    if (
      obj &&
      obj.value.propertyTypeIds &&
      obj.value.propertyTypeIds.length > 0
    )
      params['propertyTypeIds'] = obj.value.propertyTypeIds;
    if (obj && obj.value.areaIds && obj.value.areaIds.length > 0)
      params['areaIds'] = obj.value.areaIds;

    return ApiService.query('/reports/ads-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_ADS_REPORTS, data);
      }
    );
  }

  @Action
  [Actions.GET_USERS_REPORTS](obj) {
    const params = { dateFrom: '', dateTo: '' };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/user-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_USERS_REPORTS, data);
      }
    );
  }

  @Action
  [Actions.GET_REGISTERED_TRADE_REPORTS](obj) {
    try {
      const params = { dateFrom: '', dateTo: '' };

      if (obj && obj.dateFrom) params.dateFrom = String(obj.dateFrom);
      if (obj && obj.dateTo) params.dateTo = String(obj.dateTo);
      if (obj && obj.priceFrom) params['priceFrom'] = Number(obj.priceFrom);
      if (obj && obj.priceTo) params['priceTo'] = Number(obj.priceTo);
      if (obj && obj.sizeFrom) params['sizeFrom'] = Number(obj.sizeFrom);
      if (obj && obj.sizeTo) params['sizeTo'] = Number(obj.sizeTo);

      if (obj?.areaIds?.length > 0) params['areaIds'] = obj.areaIds;
      if (obj?.propertyTypeIds?.length > 0)
        params['propertyTypeIds'] = obj.propertyTypeIds;
      if (obj?.statusIds?.length > 0) params['statusIds'] = obj.statusIds;
      if (obj?.statusNotesIds?.length > 0)
        params['statusNotesIds'] = obj.statusNotesIds;
      if (obj?.propertyCategoryValues?.length > 0)
        params['propertyCategoryValues'] = obj.propertyCategoryValues;

      ApiService.setAuthorizationHeader();
      return ApiService.query('/reports/registered-trades-count', {
        params,
      }).then(({ data }) => {
        this.context.commit(Mutations.SET_REGISTERED_TRADE_REPORTS, data);
      });
    } catch (error) {
      console.log(error);
    }
  }

  @Action
  [Actions.GET_REGISTERED_TRADE_TOP_REPORTS](obj) {
    try {
      // console.log(obj);
      const params = {
        dateFrom: '',
        dateTo: '',
        propertyStatusId: 0,
      };

      if (obj && obj.value.dateFrom)
        params.dateFrom = String(obj.value.dateFrom);

      if (obj && obj.value.status && obj.value.status.length > 0)
        params['status'] = obj.value.status;
      if (
        obj &&
        obj.value.statusNotesIds &&
        obj.value.statusNotesIds.length > 0
      )
        params['statusNotesIds'] = obj.value.statusNotesIds;
      if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);
      if (obj && obj.value.propertyStatusId)
        params.propertyStatusId = obj.value.propertyStatusId;

      if (obj.value.selectedArea && obj.value.selectedArea.length > 0) {
        params['areasIds'] = obj.value.selectedArea;
      }
      if (obj.value.propertyGroupingId) {
        params['propertyGroupingId'] = obj.value.propertyGroupingId;
      }

      ApiService.setAuthorizationHeader();
      return ApiService.query('/reports/registered-trades-top', {
        params,
      }).then(({ data }) => {
        this.context.commit(Mutations.SET_REGISTERED_TRADE_TOP_REPORTS, data);
      });
    } catch (error) {
      console.log(error);
    }
  }

  // @Action
  // [Actions.GET_REGISTERED_TRADE_TOTALS_REPORTS](obj) {
  //   const params = {
  //     dateFrom: '',
  //     dateTo: '',
  //     areasIds: [],
  //   };

  //   if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

  //   if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

  //   if (obj && obj.value.selectedArea.length > 0) {
  //     debugger;
  //     params['areasIds'] = obj.value.selectedArea;
  //   }

  //   ApiService.setAuthorizationHeader();
  //   return ApiService.query('/reports/registered-trades-totals', {
  //     params,
  //   }).then(({ data }) => {
  //     this.context.commit(Mutations.SET_REGISTERED_TRADE_TOTALS_REPORTS, data);
  //   });
  // }

  @Action
  [Actions.GET_REGISTERED_TRADE_PER_QUARTER_REPORTS](obj) {
    const params = { dateFrom: '', dateTo: '' };
    console.log(obj);

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    if (obj && obj.value.status && obj.value.status.length > 0)
      params['status'] = obj.value.status;

    if (obj && obj.value.statusNotesIds && obj.value.statusNotesIds.length > 0)
      params['statusNotesIds'] = obj.value.statusNotesIds;

    if (obj.value.includedAreas && obj.value.includedAreas.length > 0) {
      params['areasIds'] = obj.value.includedAreas;
    }
    if (obj.value.selectedArea && obj.value.selectedArea.length > 0) {
      params['excludeAreasIds'] = obj.value.selectedArea;
    }
    if (
      obj.value.selectedPropertyStatus &&
      obj.value.selectedPropertyStatus.length > 0
    ) {
      params['propertyStatusIds'] = obj.value.selectedPropertyStatus;
    }
    if (
      obj.value.selectedPropertyType &&
      obj.value.selectedPropertyType.length > 0
    ) {
      params['excludePropertyTypeIds'] = obj.value.selectedPropertyType;
    }
    if (obj.value.propertyGroupingId) {
      params['propertyGroupingId'] = obj.value.propertyGroupingId;
    }

    if (obj.value.selectedGov && obj.value.selectedGov.length > 0) {
      params['govIds'] = obj.value.selectedGov;
    }
    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/registered-trades-per-count', {
      params,
    }).then(({ data }) => {
      this.context.commit(
        Mutations.SET_REGISTERED_TRADE_PER_QUARTER_REPORTS,
        data
      );
    });
  }

  @Action
  [Actions.GET_AUCTIONS_REPORTS](obj) {
    const params = { dateFrom: '', dateTo: '' };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/auction-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_AUCTIONS_REPORTS, data);
      }
    );
  }

  @Action
  [Actions.GET_AUCTION_PROPERTIES_REPORT](obj) {
    const params: Record<string, any> = {};

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);
    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    if (obj && obj.value.organiserIds && obj.value.organiserIds.length > 0) {
      params['organiserIds'] = obj.value.organiserIds;
    }
    if (obj && obj.value.onlyFullySold) {
      params['onlyFullySold'] = obj.value.onlyFullySold;
    }

    if (obj && obj.value.areaIds && obj.value.areaIds.length > 0) {
      params['areaIds'] = obj.value.areaIds;
    }

    if (
      obj &&
      obj.value.excludeAreaIds &&
      obj.value.excludeAreaIds.length > 0
    ) {
      params['excludeAreaIds'] = obj.value.excludeAreaIds;
    }
    if (
      obj &&
      obj.value.excludeTypeIds &&
      obj.value.excludeTypeIds.length > 0
    ) {
      params['excludeTypeIds'] = obj.value.excludeTypeIds;
    }
    if (
      obj &&
      obj.value.excludeCategoryIds &&
      obj.value.excludeCategoryIds.length > 0
    ) {
      params['excludeCategoryIds'] = obj.value.excludeCategoryIds;
    }

    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/auction-properties-report', {
      params,
    }).then(({ data }) => {
      this.context.commit(Mutations.SET_AUCTION_PROPERTIES_REPORT, data);
    });
  }

  @Action
  [Actions.GET_AUCTION_REPORT](obj) {
    const params: Record<string, any> = {};

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);
    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    if (
      obj &&
      obj.value.propertyTypeIds &&
      obj.value.propertyTypeIds.length > 0
    ) {
      params['propertyTypeIds'] = obj.value.propertyTypeIds;
    }
    if (obj && obj.value.areaIds && obj.value.areaIds.length > 0) {
      params['areaIds'] = obj.value.areaIds;
    }
    if (obj && obj.value.organiserIds && obj.value.organiserIds.length > 0) {
      params['organiserIds'] = obj.value.organiserIds;
    }
    if (obj && obj.value.onlyFullySold) {
      params['onlyFullySold'] = obj.value.onlyFullySold;
    }

    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/auction-report', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_AUCTION_REPORT, data);
      }
    );
  }

  @Action
  [Actions.GET_ACTIVE_ADS_SUMMARY_REPORT](obj) {
    const params: Record<string, any> = {};

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);
    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);
    if (obj && obj.value.areaId) params.areaId = Number(obj.value.areaId);
    if (obj && obj.value.categoryId)
      params.categoryId = Number(obj.value.categoryId);

    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/active-ads-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_ACTIVE_ADS_SUMMARY_REPORT, data);
      }
    );
  }

  @Action
  [Actions.GET_ESTIMATOR_REPORTS](obj) {
    const params = { dateFrom: '03/05/2023', dateTo: '' };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/estimator-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_ESTIMATOR_REPORTS, data);
      }
    );
  }
  @Action
  [Actions.GET_REGISTERED_TRADE_TOP_AREAS_REPORTS](obj) {
    debugger;
    const params = {
      dateFrom: '',
      dateTo: '',
      propertyStatusIds: [],
      govIds: 0,
    };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    if (obj && obj.value.status && obj.value.status.length > 0)
      params['status'] = obj.value.status;
    if (obj && obj.value.statusNotesIds && obj.value.statusNotesIds.length > 0)
      params['statusNotesIds'] = obj.value.statusNotesIds;

    if (obj && obj.value.propertyStatusId)
      params['propertyStatusId'] = obj.value.propertyStatusId;

    if (
      obj.value.selectedPropertyStatus &&
      obj.value.selectedPropertyStatus.length > 0
    ) {
      params['propertyStatusIds'] = obj.value.selectedPropertyStatus;
    }
    if (obj.value.propertyGroupingId) {
      params['propertyGroupingId'] = obj.value.propertyGroupingId;
    }

    if (obj && obj.value.govIds) params['govIds'] = obj.value.govIds;
    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/registered-trades-top-areas-count', {
      params,
    }).then(({ data }) => {
      this.context.commit(
        Mutations.SET_REGISTERED_TRADE_TOP_AREAS_REPORTS,
        data
      );
    });
  }

  @Action
  [Actions.GET_REGISTERED_TRADES_DESC]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/reports/registered-trades-property-status')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_REGISTERED_TRADES_DESC, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
  @Action
  [Actions.GET_REGISTERED_TRADE_TOTALS_REPORTS](obj) {
    const params = {
      dateFrom: '',
      dateTo: '',
      govIds: [],
      propertyStatusIds: [],
      status: '',
    };
    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);
    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);
    if (obj && obj.value.status && obj.value.status.length > 0)
      params['status'] = obj.value.status;
    if (obj && obj.value.statusNotesIds && obj.value.statusNotesIds.length > 0)
      params['statusNotesIds'] = obj.value.statusNotesIds;
    if (obj.value.selectedGov && obj.value.selectedGov.length > 0) {
      params['govIds'] = obj.value.selectedGov;
    }
    if (obj.value.propertyGroupingId) {
      params['propertyGroupingId'] = obj.value.propertyGroupingId;
    }
    if (
      obj.value.selectedPropertyStatus &&
      obj.value.selectedPropertyStatus.length > 0
    ) {
      params['propertyStatusIds'] = obj.value.selectedPropertyStatus;
    }
    ApiService.setAuthorizationHeader();
    return ApiService.query('/reports/registered-trades-totals', {
      params,
    }).then(({ data }) => {
      this.context.commit(Mutations.SET_REGISTERED_TRADE_TOTALS_REPORTS, data);
    });
  }
}
